import type {components, paths} from '../../openapi/auth.swagger';
import {axiosInstance} from '../axiosInstance';

type FetchNotificationsOperation = paths['/executor_web/notifications']['get'];

export type FetchNotificationsQuery = NonNullable<FetchNotificationsOperation['parameters']['query']>;
export type NotificationsResponse = FetchNotificationsOperation['responses'][200]['content']['application/json'];
export type ExecutorNotification = components['schemas']['Notification'];

/** GET `/executor_web/notifications` — список уведомлений */
export function fetchNotifications(query?: FetchNotificationsQuery, signal?: AbortSignal) {
	return axiosInstance.get<NotificationsResponse>('notifications', {params: query, signal});
}
